import { render, staticRenderFns } from "./feeApply.vue?vue&type=template&id=2ec84fce&scoped=true&"
import script from "./feeApply.vue?vue&type=script&lang=js&"
export * from "./feeApply.vue?vue&type=script&lang=js&"
import style0 from "./feeApply.vue?vue&type=style&index=0&id=2ec84fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec84fce",
  null
  
)

export default component.exports